var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer flex align-center justify-space-between",class:{ above: _vm.position === 'above' }},[_c('div'),_vm._m(0),_c('div')])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_vm._v("Made by "),_c('a',{attrs:{"href":"https://www.tennosbusiness.com/","target":"_blank"}},[_vm._v("Tennos Business.com")])])])
}]

export { render, staticRenderFns }